import { createFileRoute } from '@tanstack/react-router';
import { iamService } from '@/api/services/iam';
import { head } from '@/router/Head';
import { SecurityIndexComponent } from './route.component';

export const Route = createFileRoute('/_authenticated/_dashboard/security')({
  beforeLoad: () => ({ listUserMfaMethodsQuery: iamService.listUserMfaMethodsQuery() }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(context.listUserMfaMethodsQuery);
  },
  staticData: {
    title: 'Security',
  },
  head,
  component: SecurityIndexComponent,
});
